import { createAsyncTypes } from 'utils/ActionCreator'

export const DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC = createAsyncTypes(
  'DONT_SHOW_REINTEGRATION_ANYMORE_ASYNC',
  'Reintegration'
)
